import React from "react";
import useAnalytics from "../../hooks/useAnalytics";

const AnalyticsContext = React.createContext<ReturnType<
  typeof useAnalytics
> | null>(null);

export default AnalyticsContext;
